//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DeltaPP_info'

}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Anae/DeltaPP_info.vue